import { isTV } from 'app/device';
import { useThemeContext } from 'context';
import { If } from 'helpers';
import { useSessionTracker } from 'hooks';
import { useEffect } from 'react';
import { SESSION_STATE } from 'slices';
import { NaclClient, WebClient } from './streaming-client';

export function GameSession() {
    const { sessionState } = useSessionTracker();
    const { startWallpaperLoop, stopWallpaperLoop } = useThemeContext();

    useEffect(() => {
        // Hide all dom nodes when session is running
        if (sessionState.id === SESSION_STATE.RUNNING.id) {
            stopWallpaperLoop();
            document.getElementById('root').classList.add('freeze');
        }
        return () => {
            startWallpaperLoop();
            document.getElementById('root').classList.remove('freeze');
        };
    }, [sessionState, startWallpaperLoop, stopWallpaperLoop]);

    return (
        <If condition={sessionState.id === SESSION_STATE.RUNNING.id}>
            <If condition={isTV}>
                <NaclClient />
            </If>
            <If condition={!isTV}>
                <WebClient />
            </If>
        </If>
    );
}
